import { AuctionStatus } from '@/types/LiveAuctionState';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import {
    getItemModelBuyNowStatus,
    getItemModelCatalogStatus,
    getItemModelTitle,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { NewAccountWalkthroughSteps } from '@/types/walkthroughs';
import { ReactElement } from 'react';
import { useAppSelector } from '@/redux/hooks';
import { useIsMobileLayout } from '@/hooks/useIsMobileLayout';
import { useLaNewItemPageLayoutExperiment } from '@/utils/amplitude/experiments/hooks/useLaNewItemPageLayout.experiment';
import BuyNowComponent from '@/components/ItemBidding/BuyNowComponent';
import ItemBidding from '@/components/ItemBidding/ItemBidding';
import PageTitle from '@/components/PageTitle/PageTitle';

type Props = {
    className?: string;
    itemId: number;
    onCountdownEnd: () => void;
};

const ItemPageRightTop = ({ className, itemId, onCountdownEnd }: Props) => {
    const buyNowStatus = useAppSelector((state) => getItemModelBuyNowStatus(state, itemId));
    const catalogStatus = useAppSelector((state) => getItemModelCatalogStatus(state, itemId));
    const title = useAppSelector((state) => getItemModelTitle(state, itemId));
    const buyNowAvailable = buyNowStatus === 1 && catalogStatus === AuctionStatus.Done;
    const isMobile = useIsMobileLayout();

    // This handles exposure for both control and treatment
    const isLaNewItemPageLayoutExperiment = useLaNewItemPageLayoutExperiment();

    let purchaseComponent: ReactElement;

    // BuyNow is availible in the HUI BidCanvas, which will be displayed in the experiment through ItemBidding
    if (buyNowAvailable && !isLaNewItemPageLayoutExperiment) {
        purchaseComponent = <BuyNowComponent itemId={itemId} />;
    } else {
        purchaseComponent = (
            <ItemBidding
                itemId={itemId}
                onCountdownEnd={onCountdownEnd}
            />
        );
    }

    return (
        <div className={cn(className)}>
            {isMobile && !isLaNewItemPageLayoutExperiment && (
                <PageTitle
                    className="!m-0"
                    data-walkthrough-step={NewAccountWalkthroughSteps.Item1}
                    title={title}
                />
            )}
            {purchaseComponent}
        </div>
    );
};

export default ItemPageRightTop;
